
import Vue from 'vue';
import { Button, Icon } from '@descomplica/vue-components';
import { ChannelModel } from '@/models/forumAPI/ChannelModel';
import HeaderForum from '../components/forum/HeaderForum.vue';
import DiscussionItem from '../components/forum/DiscussionItem.vue';
import DiscussionItemMobile from '../components/forum/DiscussionItemMobile.vue';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import i18n from '../i18n';
import { PaginationInfo } from '@/store/forumAPI/channels/state';
import { isMobileDevice } from '@/helpers/mobile';
import { getCourseCategory } from '@/helpers/category';
import { DiscussionModel } from '@/models/forumAPI/DiscussionModel';
import scrollDirective from '@/directives/scroll';
import { CourseModel } from '@descomplica/dex-models';

export default Vue.extend({
  name: 'Channel',
  components: {
    HeaderForum,
    DiscussionItem,
    Button,
    Icon,
    DiscussionItemMobile,
  },
  directives: {
    scroll: scrollDirective,
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    await this.pullChannelInfo();
  },
  data() {
    return {
      defaultPageSize: 10,
      initialPage: 0,
      currentPage: 1,
      isOrderedByMostRecent: true,
      isTitle: false as Boolean,
      isButton: false as Boolean,
    };
  },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    channel(): ChannelModel {
      const { channelId } = this.$route.params;
      return this.$store.getters.forumAPIChannelById(channelId);
    },
    paginatedDiscussions(): DiscussionModel[] {
      const { channelId } = this.$route.params;
      return this.$store.getters.paginatedDiscussionsByChannelId(channelId);
    },
    buttonMessage(): String {
      return this.channel && this.channel.isPresentation()
        ? i18n.tc('presentMyself')
        : i18n.tc('createDiscussion');
    },
    paginationsNumber(): number {
      const { numberOfItems } = this.paginationInfo || {};
      return numberOfItems ? Math.ceil(numberOfItems / this.defaultPageSize) : 0;
    },
    visiblePaginations(): number[] {
      const maxElements = isMobileDevice() ? 3 : 9;
      const halfElements = (maxElements - 1) / 2;
      if (this.paginationsNumber <= maxElements) {
        return Array.from({ length: this.paginationsNumber }, (_, i) => i + 1);
      }

      let windowStart = this.currentPage - halfElements;
      let windowEnd = this.currentPage + halfElements;

      if (windowStart < 1) {
        windowEnd += 1 - windowStart;
        windowStart = 1;
      }

      if (windowEnd > this.paginationsNumber) {
        windowStart -= windowEnd - this.paginationsNumber;
        windowEnd = this.paginationsNumber;
      }

      const list = [];
      if (windowStart !== 1) {
        list.push(1);
        list.push(0);
      }

      for (let i = windowStart; i <= windowEnd; i += 1) {
        list.push(i);
      }

      if (windowEnd !== this.paginationsNumber) {
        list.push(0);
        list.push(this.paginationsNumber);
      }

      return list;
    },
    paginationInfo(): PaginationInfo {
      return this.$store.getters.getPaginationInfo;
    },
    headerForum(): any {
      return this.$refs.headerForum;
    },
    createButton(): any {
      return this.$refs.createButton;
    },
  },
  async created() {
    await this.pullChannelInfo();
  },
  methods: {
    trackChannelOpened(): void {
      Analytics.trackEvent(EVENT_LABELS.forumChannelOpened, {
        channel_name: this.channel.name,
        category: getCourseCategory(this.currentCourse),
      });
    },
    goToCreateDiscussion(): void {
      this.$router.push({
        name: 'createDiscussion',
      });
    },
    async pullChannelInfo() {
      await this.$store.dispatch('PULL_FORUM_API_CHANNEL_INFO', {
        channelId: this.$route.params.channelId,
        orderByDesc: this.isOrderedByMostRecent,
        first: this.defaultPageSize,
        skip: this.initialPage,
      });

      await this.$store.dispatch('GET_PROFILES_BY_DEX_IDS', this.channel.uniqueParticipantIdList);
    },
    async changeOrderBy() {
      this.toggleCurrentOrder();
      this.currentPage = 1;
      await this.$store.dispatch('PULL_FORUM_API_CHANNEL_INFO', {
        channelId: this.$route.params.channelId,
        orderByDesc: this.isOrderedByMostRecent,
        first: this.defaultPageSize,
        skip: this.initialPage,
      });
      window.scrollTo(0, 0);
    },
    async changePage(pageNumber: number) {
      this.currentPage = pageNumber;
      await this.$store.dispatch('PULL_FORUM_API_CHANNEL_INFO', {
        channelId: this.$route.params.channelId,
        orderByDesc: this.isOrderedByMostRecent,
        first: this.defaultPageSize,
        skip: this.defaultPageSize * (this.currentPage - 1),
      });
      window.scrollTo(0, 0);
    },
    toggleCurrentOrder() {
      this.isOrderedByMostRecent = !this.isOrderedByMostRecent;
    },
    nextPage() {
      if (this.currentPage === this.paginationsNumber) return;
      this.changePage(this.currentPage + 1);
    },
    previousPage() {
      if (this.currentPage === 1) return;
      this.changePage(this.currentPage - 1);
    },
    getPaginationLabel(i: number) {
      if (i === 0) {
        return '...';
      }

      return `${i}`;
    },
    handlerScroll() {
      this.isTitle = window.scrollY > this.headerForum.$el.offsetTop;
      this.isButton = window.scrollY > this.createButton.$el.offsetTop;
    },
  },
});
